<template>
    <v-menu 
        v-model="menu" 
        offset-y 
        :close-on-content-click="false" 
        left
    >
        <template v-slot:activator="{ on }">
            <v-btn 
                icon 
                v-on="on" 
                tabindex="-1"
            >
                <v-icon>mdi-calendar</v-icon>
            </v-btn>
        </template>
        <v-date-picker
            v-model="picker"
            type="date"
            locale="jp-ja"
            color="teal accent-4"
            @click="menu = false"
            :day-format="date => new Date(date).getDate()"
        ></v-date-picker>
    </v-menu>
</template>

<script>
    import moment from 'moment';
    export default {
        data() {
            return {
                menu: false
            };
        },
        computed: {
            picker: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.menu = false;
                    this.$emit("input", moment(value).format('YYYY/MM/DD'));
                }
            }
        }
    };
</script>

<style scoped>
    .mdi-calendar {
        padding-top: 10px;
    }
</style>